<script lang="ts">
	import { page } from '$app/stores';
	import ProductBanner from './Banners/ProductBanner.svelte';
	import RichTextPreview from './RichTextPreview/RichTextPreview.svelte';

	export let content: object = {};

	$: blocks = content?.blocks || [];
	$: middleIndex = Math.min(getThirdParagraphIndex(blocks) + 1, blocks?.length - 1);
	$: middleBlock = blocks[middleIndex] || null;
	$: isMiddleBlockAList = !middleBlock ? false : middleBlock.type == 'list';

	$: firstHalf = {
		...content,
		blocks: blocks?.slice(0, middleIndex)
	};
	$: secondHalf = {
		...content,
		blocks: blocks?.slice(middleIndex)
	};

	function getThirdParagraphIndex(blocks: { type: string }[]) {
		let count = 0;

		for (let index = 0; index < blocks.length; index++) {
			const block = blocks[index];
			if (block.type !== 'paragraph') continue;

			count++;

			if (count === 3) return index;
		}

		return blocks.length;
	}
</script>

<section class="pt-2 text-left font-robotoslab text-lg md:text-xl">
	<RichTextPreview content={firstHalf} />
	<ProductBanner class="my-7 w-full" intent={$page?.data?.article?.category?.main?.slug} />
	<RichTextPreview content={secondHalf} />
</section>
